import Reveal from "@/components/feature/Reveal";
import SectionTitle from "@/components/feature/SectionTitle";
import { mainArea, neighborAreas, areaNote } from "@/mocks/areas";
import MascotAccent from "@/components/feature/MascotAccent";

export default function Area() {
  return (
    <section id="area" className="relative overflow-hidden bg-background-50 py-16 md:py-24">
      <MascotAccent variant="cert" className="bottom-8 left-6 hidden h-16 w-16 xl:block" />
      <div className="site-container">
        <Reveal>
          <SectionTitle
            upper="AREA"
            under="会社から近い地域のお客様を大切に、地域密着型のサービスとして対応します。"
          >
            対応エリア
          </SectionTitle>
        </Reveal>

        <div className="mt-12 grid gap-6 lg:grid-cols-[0.9fr_1.1fr]">
          <Reveal>
            <div className="flex h-full flex-col items-center justify-center rounded-lg border-2 border-primary-400 bg-primary-50 p-7 text-center">
              <span className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-map-pin-2-fill text-2xl" />
              </span>
              <p className="mt-3 text-xs font-bold tracking-wide text-primary-700">対応エリアの中心</p>
              <p className="font-heading text-3xl font-black text-primary-900">{mainArea.city}</p>
              <p className="mt-3 max-w-xs text-base leading-relaxed text-primary-800">{mainArea.text}</p>
            </div>
          </Reveal>

          <Reveal delay={80}>
            <div className="rounded-lg border border-background-200 bg-background-100/70 p-6">
              <p className="text-base font-bold text-foreground-800">春日部市を中心に、近隣地域にも対応</p>
              <ul className="mt-4 flex flex-wrap gap-2">
                {neighborAreas.map((area) => (
                  <li
                    key={area}
                    className="rounded-full border border-background-200 bg-background-50 px-3.5 py-2 text-sm font-bold text-foreground-700"
                  >
                    {area}
                  </li>
                ))}
              </ul>
              <p className="mt-5 flex items-start gap-2 text-sm leading-relaxed text-foreground-500">
                <i className="ri-information-line mt-0.5" />
                {areaNote}
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}